<template>
  <div>
    <router-view></router-view>
    <footbottom></footbottom>
  </div>
</template>
<script>
  import footbottom from '@/footer'
  export default{
    components:{
      footbottom
    }
  }
</script>



// WEBPACK FOOTER //
// src/admin.vue